import PhoneCall from "./phone-call";
import i18n from "@/i18n";
import store from "@/store";
class InboundCall extends PhoneCall {
	constructor(callInstance) {
		store.commit("voice/setLoadingCallDetails", true);
		super(callInstance, true);
		store.commit("voice/setLoadingCallDetails", false);
		this.direction = "inbound";
	}

	// Answering a call for another group (button or headset) switches the user to that group,
	// otherwise group-scoped actions on the call (e.g. park) are refused
	accept = async () => {
		this.callInstance?.accept();

		const { forGroupId, forGroupLabel, fromQueue } = this.callDetails ?? {};

		if (fromQueue || !forGroupId || forGroupId === store.getters["login/userGroup"]?.id) {
			return;
		}

		// switchUserGroup never rejects (also called fire-and-forget by the headset) and reports its own failure
		if (await store.dispatch("login/switchUserGroup", forGroupId)) {
			store.commit("alerts/add", {
				type: "success",
				message: i18n.t("changing-group", { label: forGroupLabel }),
				timeout: true
			});
		}
	};

	static from(callInstance) {
		return new InboundCall(callInstance);
	}
}

export default InboundCall;
